import {AdapterProps, FieldAdapter} from '../field-factory';
import {
  PasswordInput as MantinePasswordInput,
  PasswordInputProps,
} from '@mantine/core';
import {FC} from 'react';

export type $PasswordInputAdapterProps = AdapterProps<PasswordInputProps>;

export const $PasswordInputAdapter: FC<
  FieldAdapter<$PasswordInputAdapterProps>
> = ({inputProps: {onChange, ...inputProps}, control}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: PasswordInputProps['onChange'] = (value) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  return (
    <MantinePasswordInput
      error={invalid}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};